import config from '@/config';
import {stringToBoolean} from "@/utils/utils";

export default function showUX({next}) {
    if (stringToBoolean(config.showUx)) {
        return next();
    }
    return next('/login');
}
